module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showCard) ? _c('div', {
    staticClass: "customer-card-box"
  }, [_c('div', {
    staticClass: "box-cell"
  }, [_c('button', {
    staticClass: "close",
    on: {
      "click": _vm.show
    }
  }), _vm._v(" "), (!_vm.hasLogin) ? _c('img', {
    attrs: {
      "alt": "客户卡片",
      "src": require("../images/customer-card-1.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasLogin) ? _c('img', {
    attrs: {
      "alt": "客户卡片",
      "src": require("../images/customer-card-2.png")
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-info"
  }, [(_vm.hasLogin && _vm.customerData.daily.length > 0) ? _c('div', [_c('span', {
    staticClass: "card-info-title"
  }, [_vm._v("日常对接")]), _vm._v(" "), _vm._l((_vm.customerData.daily), function(item, index) {
    return _c('div', [_c('p', {
      staticClass: "info-body"
    }, [_vm._v(_vm._s(item.role) + ":\t"), _c('span', [_vm._v(_vm._s(item.name) + "\t")]), _c('span', [_vm._v(_vm._s(item.phone))])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "margin-left": "12%"
      }
    }, [_c('a', {
      staticClass: "url-new-version",
      attrs: {
        "href": "mailto:" + item.email
      }
    }, [_vm._v(_vm._s(item.email))])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_c('span', {
    staticClass: "card-info-title"
  }, [_vm._v("服务保障和监督投诉")]), _vm._v(" "), _vm._l((_vm.customerData.service), function(item, index) {
    return _c('div', [_c('p', {
      staticClass: "info-body"
    }, [_vm._v(_vm._s(item.role) + ":\t"), _c('span', [_vm._v(_vm._s(item.name) + "\t")]), _c('span', [_vm._v(_vm._s(item.phone))])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "margin-left": "12%"
      }
    }, [_c('a', {
      staticClass: "url-new-version",
      attrs: {
        "href": "mailto:" + item.email
      }
    }, [_vm._v(_vm._s(item.email))])])])
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_c('span', {
    staticClass: "card-info-title"
  }, [_vm._v("宝贵建议")]), _vm._v(" "), _vm._l((_vm.customerData.recommend), function(item, index) {
    return _c('div', [_c('p', {
      staticClass: "info-body"
    }, [_vm._v("\t"), _c('span', [_vm._v(_vm._s(item.name) + "\t")]), _c('span', [_vm._v(_vm._s(item.phone))])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "margin-left": "12%"
      }
    }, [_c('a', {
      staticClass: "url-new-version",
      attrs: {
        "href": "mailto:" + item.email
      }
    }, [_vm._v(_vm._s(item.email))])])])
  })], 2)])])]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-c2fc67bc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c2fc67bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":false}!./src/components/customer-card.vue
// module id = 1373
// module chunks = 61